import service from '../../services/api/apiService'
import { ACTION_USER_INFO, accessTokenKey } from '../../constants'
import { API_ERROR_STATUS } from '../../services/api/apiStatuses'
import { STATES, UserDetails } from '../../interfaces'
import { UserRole } from '../configureRoles/constants'
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'

export interface UserState {
  isAuth: boolean
  fetchingAuthStatusState: STATES
  isPasswordReset: boolean
  isReadOnly: boolean
  userInfo?: UserDetails
  serverError?: boolean
}
export interface Token_Params {
  session_state: string
  code: string
  redirectURI: string
}
export const initialState: UserState = {
  isAuth: !!window.localStorage.getItem(accessTokenKey),
  fetchingAuthStatusState: STATES.success,
  isPasswordReset: false,
  userInfo: {} as UserDetails,
  isReadOnly: true,
  serverError: false
}

export const fetchUserInfo = createAsyncThunk(
  ACTION_USER_INFO,
  async (_, { rejectWithValue }): Promise<UserDetails> => {
    const userInfo = await service.getUserInfo().catch((e) => {
      return rejectWithValue({ loggedInViaSaaS: e.loggedInViaSaaS })
    })
    return userInfo
  }
)
export const ACTION_TOKEN = 'fetch/token'
export const fetchToken = createAsyncThunk(
  ACTION_TOKEN,
  async (params: Token_Params, { rejectWithValue }) => {
    const tokenRes = await service.getToken(params).catch((e) => {
      const statusMessage =
        e?.message === API_ERROR_STATUS.UNAUTHORIZED ? null : 'login.error.invalidCredentials'

      return rejectWithValue({ statusMessage })
    })
    window.localStorage.setItem(accessTokenKey, tokenRes[accessTokenKey])
    setAuth(true)
    return tokenRes
  }
)

const authenticationSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<boolean>) => {
      state.isAuth = action.payload
    },
    setServerError: (state, action: PayloadAction<boolean>) => {
      state.serverError = action.payload
    },
    setUserDetails: (state, action: PayloadAction<UserDetails>) => {
      state.userInfo = action.payload
    },
    setUserDetailsAndReadOnly: (state, action: PayloadAction<UserDetails>) => {
      const { payload } = action
      state.userInfo = action.payload
      if (payload && payload.roles && payload.roles.length) {
        state.isReadOnly = payload.roles[0].name !== UserRole.ADMIN
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserInfo.pending, (state) => {
      state.fetchingAuthStatusState = STATES.pending
    })
    builder.addCase(fetchUserInfo.fulfilled, (state, { payload }) => {
      state.userInfo = payload
      if (payload && payload.roles && payload.roles.length) {
        state.isReadOnly = payload.roles[0].name !== UserRole.ADMIN
      }
    })
  }
})
export const {
  setAuth,
  setServerError,
  setUserDetails,
  setUserDetailsAndReadOnly
} = authenticationSlice.actions
export default authenticationSlice.reducer
